function PlayerService($http, $httpParamSerializer, $rootScope, $q, AppSettings, AuthService, CommonService) {
    'ngInject';

    const service = {};

    //선수 목록 조회
    service.getPlayers = function(params){
        const url = AppSettings.apiUrl.restRoot + 'main/players';
        return CommonService.post(url, params);
    };

    // service.getPlayers2 = function(params){
    //     const url = AppSettings.apiUrl.restRoot + 'main/players';
    //     return CommonService.post(url, params);
    // };


    //부상 정보 입력/수정
    service.getPlayerBiometricInfo = function(params) {
        const url = AppSettings.apiUrl.restRoot + 'main/info';
        return CommonService.post(url, params);
    }

    service.getPlayerLocationInfo = function(params) {
        // const url = AppSettings.apiUrl.restRoot + 'main/info';
        const url = AppSettings.apiUrl.restRoot + 'main/team_info';

        return CommonService.post(url, params);
    }


    return service;
}

export default {
    name: 'PlayerService',
    fn: PlayerService
}